<!-- Main Container with constrained width -->
<div class="w-full max-w-full">
  <!-- Compact Controls Section -->
  <div class="mb-3 w-full">
    <div class="flex items-center justify-between gap-2 flex-wrap">
      <!-- View mode buttons -->
      <div class="flex items-center gap-2">
        <!-- Filtro rápido de organizador -->
        <div class="flex items-center rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
          <button
            type="button"
            (click)="setOrganizadorFilter('all')"
            class="px-3 py-1.5 text-sm font-medium transition-colors"
            [ngClass]="filtroOrganizador === 'all'
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
            Todas
          </button>
          <button
            type="button"
            (click)="setOrganizadorFilter('mine')"
            class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-700"
            [ngClass]="filtroOrganizador === 'mine'
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
            Mis reuniones
          </button>
        </div>

        <button
          type="button"
          (click)="changeViewMode('status')"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors"
          [ngClass]="viewMode === 'status'
            ? 'bg-brand-500 text-white'
            : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'">
          Estado
        </button>
        <button
          type="button"
          (click)="changeViewMode('type')"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors"
          [ngClass]="viewMode === 'type'
            ? 'bg-brand-500 text-white'
            : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'">
          Tipo
        </button>
      </div>

      <!-- Action buttons -->
      <div class="flex items-center gap-1.5">
        <button
          type="button"
          (click)="toggleFilters()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path>
          </svg>
          {{ showFilters ? 'Ocultar' : 'Filtros' }}
        </button>
        <button
          type="button"
          (click)="vistaLista()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-1.5">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"></path>
          </svg>
          Lista
        </button>
        <button
          type="button"
          (click)="nuevaReunion()"
          class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
          </svg>
          Nueva reunión
        </button>
      </div>
    </div>
  </div>

  <!-- Compact Filters Panel -->
  @if (showFilters) {
    <div class="mb-3 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3 w-full">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        <!-- Búsqueda por título/descripción -->
        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Buscar por título
          </label>
          <input
            type="text"
            [(ngModel)]="filters.searchTerm"
            (ngModelChange)="applyFilters()"
            placeholder="Título o descripción..."
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
        </div>

        <!-- Filtro Estado (solo si no es el modo actual) -->
        @if (availableFilterFields.status) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
              Estado
            </label>
            <select
              [(ngModel)]="filters.idMeetingStatus"
              (ngModelChange)="applyFilters()"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
              <option [ngValue]="undefined">Todos</option>
              @for (status of meetingStatuses; track status.id) {
                <option [ngValue]="status.id">{{ status.name }}</option>
              }
            </select>
          </div>
        }

        <!-- Filtro Tipo (solo si no es el modo actual) -->
        @if (availableFilterFields.type) {
          <div>
            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
              Tipo
            </label>
            <select
              [(ngModel)]="filters.idMeetingType"
              (ngModelChange)="applyFilters()"
              class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
              <option [ngValue]="undefined">Todos</option>
              @for (type of meetingTypes; track type.id) {
                <option [ngValue]="type.id">{{ type.name }}</option>
              }
            </select>
          </div>
        }

        <!-- Filtro Fecha Desde -->
        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Fecha desde
          </label>
          <input
            type="date"
            [(ngModel)]="filters.dateFrom"
            (ngModelChange)="applyFilters()"
            (click)="$any($event.target).showPicker?.()"
            (focus)="$any($event.target).showPicker?.()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent dark:[color-scheme:dark] cursor-pointer">
        </div>

        <!-- Filtro Fecha Hasta -->
        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Fecha hasta
          </label>
          <input
            type="date"
            [(ngModel)]="filters.dateTo"
            (ngModelChange)="applyFilters()"
            (click)="$any($event.target).showPicker?.()"
            (focus)="$any($event.target).showPicker?.()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent dark:[color-scheme:dark] cursor-pointer">
        </div>

        <!-- Botón Limpiar Filtros -->
        <div class="flex items-end">
          <button
            type="button"
            (click)="clearFilters()"
            class="w-full px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700">
            Limpiar Filtros
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Loading State -->
  @if (loading) {
    <div class="flex justify-center items-center py-12">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-500"></div>
    </div>
  }

  <!-- Error State -->
  @if (error) {
    <div class="bg-error-50 dark:bg-error-900/20 border border-error-200 dark:border-error-800 text-error-700 dark:text-error-400 px-4 py-3 rounded mb-6">
      {{ error }}
    </div>
  }

  <!-- Kanban Board with Horizontal Scroll -->
  @if (!loading && !error) {
    <div class="kanban-container overflow-x-auto w-full">
      <div class="flex gap-4 pb-4" style="min-width: fit-content;">
        @for (column of columns; track column.id; let colIndex = $index) {
          <div class="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 min-w-80 w-80 flex-shrink-0">
            <!-- Header de la columna -->
            <div class="flex items-center justify-between mb-4">
              <div class="flex items-center gap-2">
                <div class="w-3 h-3 rounded-full {{ column.color }}"></div>
                <h3 class="font-semibold text-gray-900 dark:text-white">{{ column.name }}</h3>
              </div>
              <span class="text-xs font-medium text-gray-500 dark:text-gray-400 bg-white dark:bg-gray-700 px-2 py-1 rounded">
                {{ column.totalElements }} reuniones
              </span>
            </div>

            <!-- Lista de reuniones con drag & drop -->
            <div
              #columnScrollContainer
              cdkDropList
              [id]="'col-' + column.id"
              [cdkDropListData]="column.meetings"
              [cdkDropListConnectedTo]="getColumnIds()"
              (cdkDropListDropped)="drop($event, column)"
              class="min-h-125 max-h-175 overflow-y-auto space-y-3">

              @for (meeting of column.meetings; track meeting.id) {
                <div cdkDrag
                  (click)="verDetalle(meeting)"
                  class="bg-white dark:bg-gray-900 rounded-lg p-4 shadow-sm border border-gray-200 dark:border-gray-700 hover:shadow-lg transition-shadow relative group cursor-pointer">

                  <!-- Botones de acción -->
                  <div class="absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity z-10">
                    <button type="button"
                      (click)="editarReunion(meeting, $event); $event.stopPropagation()"
                      (mousedown)="$event.stopPropagation()"
                      class="p-1.5 bg-brand-500 hover:bg-brand-600 text-white rounded transition-colors cursor-pointer"
                      title="Editar">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z">
                        </path>
                      </svg>
                    </button>
                    <button type="button"
                      (click)="eliminarReunion(meeting, column, $event); $event.stopPropagation()"
                      (mousedown)="$event.stopPropagation()"
                      class="p-1.5 bg-error-500 hover:bg-error-600 text-white rounded transition-colors cursor-pointer"
                      title="Eliminar">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16">
                        </path>
                      </svg>
                    </button>
                  </div>

                  <!-- Título -->
                  <h4 class="font-medium text-gray-900 dark:text-white mb-2 pr-20">
                    {{ meeting.title }}
                  </h4>

                  <!-- Fecha y hora -->
                  <div class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 mb-2">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z">
                      </path>
                    </svg>
                    <span>{{ formatDate(meeting.datetimeStart) }}</span>
                  </div>

                  <!-- Ubicación o Link -->
                  @if (meeting.location || meeting.meetingUrl) {
                    <div class="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-400 mb-3">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z">
                        </path>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z">
                        </path>
                      </svg>
                      <span class="truncate">{{ meeting.location || meeting.meetingUrl }}</span>
                    </div>
                  }

                  <!-- Badges según el modo de vista -->
                  <div class="flex flex-wrap gap-2 mt-3">
                    <!-- INC 80: una reunión cancelada se marca aunque el negocio no tenga
                         un estado "Cancelada" (entonces solo queda el motivo). -->
                    @if (estaCancelada(meeting)) {
                      <app-badge color="error" size="sm">Cancelada</app-badge>
                    }
                    @if (viewMode !== 'status' && meeting.idMeetingStatus) {
                        <app-badge size="sm">
                            {{ getStatusName(meeting.idMeetingStatus) }}
                        </app-badge>
                    }
                    @if (viewMode !== 'type' && meeting.idMeetingType) {
                        <app-badge size="sm">
                            {{ getTypeName(meeting.idMeetingType) }}
                        </app-badge>
                    }
                    @if (meeting.contactId) {
                      <app-badge color="info" size="sm">
                        {{ getContactName (meeting.contactId) }}
                      </app-badge>
                    } 
                    @else {
                    <span class="text-xs text-gray-400">Sin contacto</span>
                    }
                  </div>

                  <!-- Indicador de arrastre -->
                  <div class="mt-3 pt-3 border-t border-gray-100 dark:border-gray-800 flex justify-center">
                    <div class="w-8 h-1 bg-gray-300 dark:bg-gray-600 rounded"></div>
                  </div>
                </div>
              }

              <!-- Estado vacío -->
              @if (column.meetings.length === 0 && !column.loading) {
                <div class="flex flex-col items-center justify-center py-12 text-gray-400 dark:text-gray-600">
                  <svg class="w-12 h-12 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z">
                    </path>
                  </svg>
                  <p class="text-sm">No hay reuniones</p>
                </div>
              }

              <!-- Scroll Sentinel para Infinite Scroll -->
              <div class="scroll-sentinel h-4"></div>

              <!-- Indicador de carga de scroll infinito -->
              @if (column.loading) {
                <div class="flex justify-center items-center py-4">
                  <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
                  <span class="ml-2 text-sm text-gray-500 dark:text-gray-400">Cargando...</span>
                </div>
              }

              <!-- Mensaje de no hay más reuniones -->
              @if (!column.hasMore && column.meetings.length > 0 && !column.loading) {
                <div class="flex justify-center items-center py-4">
                  <span class="text-xs text-gray-400 dark:text-gray-600">No hay más reuniones</span>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  <!-- Modal de detalle -->
  <app-meeting-detail-modal
  [isOpen]="showDetailModal"
  [meeting]="selectedMeeting"
  (close)="cerrarModal()">
</app-meeting-detail-modal>

  <!-- INC 66: modal de cancelación disparado al soltar en la columna "Cancelado" -->
  <app-meeting-cancel-dialog
    [isOpen]="showCancelDialog"
    [meeting]="accionMeeting"
    [targetStatusId]="accionTargetStatusId"
    (cancelled)="onDropAccionCancelada()"
    (confirmed)="onDropAccionConfirmada()">
  </app-meeting-cancel-dialog>

  <!-- INC 67: modal de reprogramación disparado al soltar en la columna "Reprogramado" -->
  <app-meeting-reschedule-dialog
    [isOpen]="showRescheduleDialog"
    [meeting]="accionMeeting"
    [targetStatusId]="accionTargetStatusId"
    (cancelled)="onDropAccionCancelada()"
    (confirmed)="onDropAccionConfirmada()">
  </app-meeting-reschedule-dialog>
</div>